import React, { useState } from 'react'
import clsx from 'clsx'
import { Box, Button, Collapse, Link, Typography } from '@material-ui/core'

import { ChevronDown as ChevronDownIcon } from 'react-feather'

import constants from 'constants/index'
import useStyles from './styles'

const AutoBlockExplanation = () => {
  const [isExplanationOpen, setIsExplanationOpen] = useState(false)

  const classes = useStyles()

  const { LINK_DOCUMENTATION_HTML } = constants.cookies.banner

  const handleExplanationToggle = () =>
    setIsExplanationOpen((isOpen) => !isOpen)

  return (
    <Box px={2} py={1}>
      <Button
        size="small"
        className={classes.toggleButton}
        aria-expanded={isExplanationOpen}
        aria-controls="auto-block-explanation"
        onClick={handleExplanationToggle}
        endIcon={
          <ChevronDownIcon
            size={16}
            className={clsx(classes.chevron, {
              [classes.chevronOpen]: isExplanationOpen,
            })}
          />
        }
      >
        Como funciona o bloqueio
      </Button>
      <Collapse in={isExplanationOpen} id="auto-block-explanation">
        <Box className={classes.content}>
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              O que o bloqueio automático faz
            </Typography>
            <Typography variant="body2" color="textSecondary">
              O banner segura os cookies das categorias bloqueadas até o
              visitante consentir e apaga esses cookies se ele recusar. Vale
              para os cookies gravados pelos scripts da página que constam na
              lista do escaneamento.
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              O que ele não alcança
            </Typography>
            <Typography variant="body2" color="textSecondary">
              O bloqueio automático não alcança: cookies gravados pelo servidor
              do site; scripts que carregam antes do banner; cookies de outros
              domínios, como Facebook e Google. Ele também{' '}
              <strong>não impede o envio de dados</strong>: os scripts continuam
              rodando e mandando informações aos serviços deles.
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              Como chegar ao bloqueio completo
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Para que um script só rode depois do consentimento, marque-o no
              HTML do site com a categoria correspondente, ou condicione as tags
              ao consentimento no Google Tag Manager.{' '}
              <Link
                href={LINK_DOCUMENTATION_HTML}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
              >
                Ver a documentação do bloqueio por script
              </Link>
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              Necessários e Outros
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Necessários nunca são bloqueados, porque o site depende deles.
              Outros reúne os cookies que o escaneamento não reconheceu, que
              muitas vezes também são necessários. Por isso vêm liberados por
              padrão. Bloquear ou liberar é escolha e responsabilidade da
              organização.
            </Typography>
          </Box>
        </Box>
      </Collapse>
    </Box>
  )
}

export default AutoBlockExplanation
